import AbstractCreditCardGateway from './AbstractCreditCardGateway';

class CreditCardGateway extends AbstractCreditCardGateway {

    selector = '#wc-stripe-card-element';

    elementType = 'payment';

    _paymentElementOptions = {};

    async mountPaymentElement(container) {
        this._elementsSubmitted = false;
        this.paymentElement.removeAllListeners();
        this.paymentElement.on('change', this.onPaymentElementChange.bind(this));
        this.paymentElement.on('loaderror', this.onLoadError.bind(this));

        this.paymentElement.mount(container);
    }

    onPaymentElementChange(event) {

    }

    onLoadError(error) {
        console.log(`Error loading payment element: ${error}`);
    }

    shouldCreatePaymentMethod() {
        return !this.isInstallmentsEnabled();

    }

    hasPaymentMethodId() {
        if (this.isInstallmentsEnabled()) {
            return this._elementsSubmitted;
        }
        return super.hasPaymentMethodId();
    }

    /**
     * Returns true if installments are enabled and a payment intent client secret
     * is available. When true, elements are created with clientSecret instead of
     * deferred intent mode.
     *
     * @returns {boolean}
     */
    isInstallmentsEnabled() {
        return !!this.settings.installments?.clientSecret;
    }

    /**
     * @override
     * When installments are enabled and not updating, replaces deferred intent
     * properties (mode) with clientSecret so Stripe renders installment options
     * natively. On update, keeps mode and omits clientSecret since elements.update()
     * doesn't accept clientSecret. Other options (appearance, etc.) are preserved.
     *
     * @param {boolean} isUpdate - True when called for elements.update()
     */
    getElementOptions(isUpdate = false) {
        const options = super.getElementOptions();
        if (this.isInstallmentsEnabled()) {
            delete options.mode;
            delete options.amount;
            delete options.currency;
            delete options.paymentMethodTypes;
            delete options.paymentMethodCreation;
            if (!isUpdate) {
                options.clientSecret = this.settings.installments.clientSecret;
            }
        }
        return options;
    }
}

export default CreditCardGateway;